/**
 * All common variables for dev and prod
 */
export const ENVIRONMENT_BASE = {
  ACCESSIBILITY_STATEMENT_CARTE_DELEGUES_URL: '/carte-des-delegues',
  ACCESSIBILITY_STATEMENT_FORMULAIRE_SAISINE_URL: '/formulaire-saisine',
  ADMIN_TECH: 'https://esante.gouv.fr/documents/413',
  AIDE_HEADER_URL: '/help-link',
  AIDE_URL: 'https://esante.gouv.fr/enreg/aide',
  API_URL: `https://${window.location.host}/sgc-proxy/`,
  ASSISTANCE_URL: 'https://esante.gouv.fr/assistance',
  CERTIFICAT_URL: '/help-certificat',
  CGU_RPPS: '/portail-RPPS-plus-mentions-legales',
  CONNECTION_ABOUT_URL: '/help-connexion-about',
  CONNECTION_HELP_CART_URL: '/help-connexion-carte',
  CONNECTION_HELP_ECPS_URL: '/help-connexion-ecps',
  E_SANTE_GOUV_URL: 'https://esante.gouv.fr',
  GESTION_HABILITATION_LIMIT_STRUCTURES_CHECKBOX: 10,
  GESTION_HABILITATION_LIMIT_USAGES_CHECKBOX: 10,
  PLATEFORME_FORMATION_RPPS: '/plateforme-formation-rpps',
  PAGE_DECLARATION_ACCESSIBILITE_URL:'declaration-accessibilite',
  PAGE_SCHEMA_PLURIANNUEL_ACCESSIBILITE_URL: 'schema-pluriannuel-daccessibilite',
  RASS_LIMIT_CONSULTATION_PM: 99,
  SANTE_GOUV_URL: 'https://sante.gouv.fr',

};
